import i18n from '@data/other/i18n';
import type { Currencies, Languages } from '@data/types/common';
import { action, autorun, makeObservable, observable } from 'mobx';
export default class Environment {
  @observable language: Languages | undefined = undefined;

  @observable currency: Currencies | undefined = undefined;

  constructor() {
    makeObservable(this);
  }

  async init() {
    // await sync(this, { key: "environment" });

    autorun(async () => {
      // if (this.currency) await this.setCurrency(this.currency);
      if (this.language) await this.changeLanguage(this.language);
    });
  }

  changeLanguage(this: void, lng?: Languages) {
    let language = 'en';

    if (lng) {
      language = lng;
    }

    return i18n.changeLanguage(language);
  }

  @action.bound setLanguage(lng: Languages) {
    this.language = lng;
  }

  @action.bound setCurrency(cur: Currencies) {
    this.currency = cur;
  }
}
